import { CourseMediaItem } from '../../types';

// Stable client id for gallery items (dnd + React keys).
export function newId(): string {
  try {
    return crypto.randomUUID();
  } catch {
    return `m-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  }
}

// The course thumbnail (shown on cards/listings) is derived from the gallery cover —
// i.e. the first item. Prefer the cover's own image; for a video cover use its poster;
// fall back to the first image anywhere in the gallery so cards never go blank.
export function deriveThumbnail(gallery: CourseMediaItem[]): string {
  const cover = gallery[0];
  let thumb = '';
  if (cover) thumb = cover.type === 'image' ? cover.url || '' : cover.posterUrl || '';
  if (!thumb) {
    const img = gallery.find((i) => i.type === 'image' && i.url);
    if (img?.url) thumb = img.url;
  }
  return thumb;
}
